import React from "react";
import Capability from "./Capability";

const Capabilities = ({ capabilities }) => {
  return capabilities.map((capability) => (
    <Capability key={capability.clinic_id} capability={capability} />
  ));
};

export default Capabilities;
